module.exports = __webpack_public_path__ + "img/item_image_11.6b723784.jpg";